
import {Link, useParams} from 'react-router-dom';
import React, {useState} from "react";

// Material UI
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
// import Chip from "@mui/material/Chip";
// import {Icon} from "@mui/material";

// MUI Icons
import {OpenInNew} from '@mui/icons-material';
// import SearchIcon from "@mui/icons-material/Search";
// import ComputerIcon from "@mui/icons-material/Computer";
// import EmailIcon from "@mui/icons-material/Email";

// App import
// import Header from "./Header";
// import Content from "./Content";
import QuickView from "../quick_view/QuickView";
import RepositoryDetails from "./RepositoryDetails";
import RepoIconImg from "../RepoIconImg";
import ErrorBoundary from "../error_handling/ErrorBoundary";

// Temp data
//import localRepositories from "../DRF_Data/repositories.json"
//const mockRepo = localRepositories['repositories'][0];

const RepositoryHomePage = (props) => {
    const params = useParams();
    const [state, setState] = useState({repository: [], DataisLoaded: false});

    const isPreviewMode = props.repository;

    React.useEffect( () => {
        if(!isPreviewMode) {
            //TODO: use props to select proper URL request
            var requestUrl = process.env.REACT_APP_API_BASE_URL + "repositories/" + params.id;
            //if (this.props.facet == "branches") requestUrl += "/branches";

            fetch(requestUrl)
                .then(response => response.json())
                .then((responseJson) => {
                    setState({
                        DataisLoaded: true,
                        repository: responseJson
                    });
                })
        } else {
            console.log(2, props.repository);
            setState({
                DataisLoaded: true,
                repository:  props.repository
            });
        }
    }, [params.id, props.repository, isPreviewMode]);

    if (state.DataisLoaded) {
        // console.log("loaded");
        // console.log(state.repository);
        return ( <React.Fragment>
            <main>
                <div>
                    <Box className='repository-page'>
                        <Grid container>
                            <Grid xs={12} container spacing={3} style={{ alignContent: 'flex-start', marginTop: '5px', paddingLeft: '7px' }}>
                                <Grid xs={12}>
                                    <div style={{ float: 'right'}}>
                                        <a href={state.repository['url']} target="_blank" rel="noreferrer">
                                            <Button size="small" variant="text" endIcon={<OpenInNew/>} style={{ marginLeft: '15px' }} className="text-button">
                                                <b>Visit Repository</b>
                                            </Button>
                                        </a>

                                        {state.repository.fairsharing_url &&
                                            <a href={state.repository['fairsharing_url']} target="_blank" rel="noreferrer">
                                                <Button size="small" variant="text" endIcon={<OpenInNew/>} style={{ marginLeft: '15px' }} className="text-button">
                                                    <b>Visit on FAIRsharing</b>
                                                </Button>
                                            </a>
                                        }
                                    </div>

                                    <div style={{ float: 'left', margin: '0px 10px 0 0' }}>
                                        <RepoIconImg altText={state.repository.name + " logo"} imageUri={'repo_logos/' + state.repository.name + '.png'} />
                                    </div>

                                    <div>
                                        { state.repository['nickname']
                                            ? <>
                                                <h2 style={{ margin: '0 0 8px 0' }}>
                                                    {state.repository['name']} ({state.repository['nickname']})
                                                </h2>
                                            </>

                                            : <><h2 style={{ margin: '0 0 8px 0' }}>
                                                {state.repository['name']}
                                            </h2></>
                                        }
                                        
                                        {(state.repository.affiliations && state.repository.affiliations.length) && state.repository.affiliations.map(affiliation =>
                                            <Typography variant='body2' key={state.repository.id + '-affiliation-' + affiliation.id}>
                                                <b>Affiliation</b>: {affiliation['name']}
                                            </Typography>
                                        )}
                                        {state.repository.new_affiliations && state.repository.new_affiliations.map(affiliation =>
                                            <Typography variant='body2' key={state.repository.id + '-affiliation-' + affiliation.id}>
                                                <b>Affiliation</b>: {affiliation}
                                            </Typography>
                                        )}
                                    </div>
                                </Grid>

                                <Grid xs={7}>
                                    <QuickView repository={state.repository} split={true} />
                                </Grid>
                                {/*
                                <Grid xs={12}>
                                    <Typography variant='body2'><b>Contact</b></Typography>
                                    { state.repository['help_url'].startsWith('http')
                                        ? <a href={state.repository['help_url']}>Contact Webpage</a>
                                        : <>{state.repository['help_url']}</>
                                    }
                                </Grid>
                                */}
                            </Grid>

                            <Grid xs={12}>
                                <ErrorBoundary fallback={<p>Oops, an error occurred with displaying this repositories details! Please contact an administrator.</p>}>
                                    <RepositoryDetails repository={state.repository} />
                                </ErrorBoundary>
                            </Grid>
                        </Grid>

                        <div style={{float: 'right'}}>
                            <Link to={'/'}>
                                <Button size="small" variant="contained" fullWidth className="large-button">Back to search</Button>
                            </Link>
                        </div>
                        <br/>
                    </Box>
                </div>
            </main>
        </React.Fragment> );
    }
};

export default RepositoryHomePage;